<template>
  <div class="page" :class="{ 'page__has-sharebar': share && bizPage }">
    <biz-viewer
      v-if="share"
      class="share-block"
      :biz="share"
      opener="share"
      @matched="onBizMatched"
    />
    <seal v-if="sealUrl" :url="sealUrl"></seal>
    <div v-if="!share" class="weui-msg">
      <div class="weui-msg__icon-area">
        <i class="weui-icon-warn weui-icon_msg"></i>
      </div>
      <div class="weui-msg__text-area">
        <h2 class="weui-msg__title">读取失败</h2>
        <p class="weui-msg__desc">您的分享链接可能已经失效！</p>
      </div>
    </div>
    <div class="footer-bar weui-dialog__ft" v-if="share && bizPage">
      <router-link
        :to="bizPage"
        v-if="account && account.companyId == companyId"
        class="weui-dialog__btn weui-dialog__btn_primary"
        replace
        >查看详情</router-link
      >
      <router-link
        :to="'/login?companyId=' + companyId + '&page=' + bizPage"
        v-else
        class="weui-dialog__btn weui-dialog__btn_primary"
        replace
        >登录后查看详情</router-link
      >
    </div>
  </div>
</template>

<script>
import BizViewer from "@/components/BizViewer.vue";
import Seal from "@/components/Seal.vue";
import Auth from "@/util/auth.js";
import Session from '@/util/session';

export default {
  components: {
    BizViewer,
    Seal,
  },
  props: {
    id: String,
    type: {
      type: String,
      default: "share",
    },
  },
  data() {
    return {
      share: {},
      bizId: null,
      companyId: null,
      sealUrl: null,
      account: null,
      bizPage: null,
    };
  },
  beforeRouteEnter(to, from, next) {
    next((vm) => {
      vm.getData();
    });
  },
  created() {
    const me = this;
    Auth.get().then(function (data) {
      me.account = data.account;
    });
  },
  beforeDestroy() {
    Session.setScopeCompany(null);
  },
  methods: {
    getData() {
      var me = this,
        url =
          me.type == "share"
            ? "/api/commons/form_share/read_biz/"
            : "/api/commons/form_identity/read/";
      me.$loading({
        url: url + me.id,
      }).then(function (res) {
        if (res.success) {
          if (res.data) {
            var viewType = res.data.viewType;
            if (!viewType) {
              viewType = res.data.bizType.toLowerCase() + "-formpanel";
            }
            Session.setScopeCompany(res.data.companyId);
            me.share = {
              viewType,
              bizData: res.data.bizData,
            };
            me.bizId = res.data.bizId;
            me.companyId = res.data.companyId;
            me.sealUrl = res.data.sealUrl;
            document.title = res.data.title;
            me.$nextTick(() => {
              // 附件设置
              me.setAttachData(res.data.attachMap);
            });
          } else {
            me.share = null;
            me.sealUrl = null;
          }
        } else {
          me.share = null;
          me.sealUrl = null;
        }
      });
    },
    /**
     * 附件接口需要鉴权，这里通过share接口直接取回附件，并自动设置
     */
    setAttachData(attactMap) {
      if (!attactMap || !Object.keys(attactMap).length) {
        return;
      }
      var me = this,
        setter = function (children) {
          if (!children || !children.length) {
            return;
          }
          children.forEach((child) => {
            if (child.$options._componentTag == "file-list") {
              if (child.value) {
                child.files = attactMap[child.value];
              }
            } else {
              setter(child.$children);
            }
          });
        };
      setter(me.$children);
    },
    onBizMatched(config) {
      if (config.page) {
        this.bizPage = config.page.replace(":id", this.bizId);
      }
    },
  },
};
</script>

<style>
.page__has-sharebar > .share-block > .page {
  margin-bottom: 48px;
}
.page__has-sharebar > .share-block > .page.page__has-bar > .footer-bar {
  bottom: 48px;
}
.share-block > .page {
  position: inherit;
  min-height: 100%;
  overflow: auto;
}
</style>